import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
  MatDialogRef as MatDialogRef,
} from '@angular/material/dialog';

export interface ConfirmDialogData {
  modalTitle?: string;
  msg?: string;
  prompt?: string;
  icon?: string;
}

/** Semantic icon variants the dialog can render (Lucide paths in the template). */
export type ConfirmDialogIcon =
  | 'delete'
  | 'logout'
  | 'approve'
  | 'reject'
  | 'status'
  | 'absent'
  | 'password'
  | 'print'
  | 'promote'
  | 'clear';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  /** Pick the icon from the title's intent; string icons from call sites are legacy. */
  get iconKind(): ConfirmDialogIcon {
    const title = (this.data.modalTitle ?? '').toLowerCase();
    if (title.includes('logout')) return 'logout';
    if (title.includes('approve')) return 'approve';
    if (title.includes('reject')) return 'reject';
    if (title.includes('status') || title.includes('update')) return 'status';
    if (title.includes('clear')) return 'clear';
    if (title.includes('close ticket')) return 'approve';
    if (title.includes('absent')) return 'absent';
    if (title.includes('password')) return 'password';
    if (title.includes('print')) return 'print';
    if (title.includes('promote')) return 'promote';
    return 'delete';
  }

  /** Confirm button honors a custom prompt ("Promote", "Yes"…), else the title. */
  get confirmLabel(): string {
    return this.data.prompt || this.data.modalTitle || 'Confirm';
  }

  get cancelLabel(): string {
    return this.data.prompt === 'Yes' ? 'No' : 'Cancel';
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onConfirm() {
    this.dialogRef.close(true);
  }
}
